// extracted by mini-css-extract-plugin
export default {"root":"tabHeading_root__r0KoO","nav":"tabHeading_nav__XCBvb","nav_item":"tabHeading_nav_item__nZQ5P","active":"tabHeading_active__qBS2L"};